<template>
  <div id="">
    <div class="table-list" v-if="list.length > 0">
      <div class="check_btn_box">
        <span><i>{{ multiple }}</i>{{ $t('enum.selected') }}</span>
        <!-- <div class="check_btn" v-if="showType=='scheduled'" :class="multiple>0?'on':''" @click="MessageBox('Unload')">Unload</div> -->
        <div class="check_btn color_333" v-if="showType != 'scheduled'" :class="multiple > 0 ? 'on' : ''" @click="MessageBox('Upload')">
          {{ $t('button.relistNow') }}
        </div>
        <div class="check_btn" :class="multiple > 0 ? 'on' : ''" @click="MessageBox('Delete')">
          {{ $t('button.delete') }}
        </div>
      </div>

      <el-table ref="multipleTable" v-if="list.length > 0" v-loading.fullscreen.lock="uploading" :data="list" class="table_box" @selection-change="handleSelectionChange" :height="screenHeight">
        <!-- :width="showType!='scheduled'?'300':'300'" -->
        <!-- <el-table-column type="selection" width="30" class-name="all_check"> </el-table-column> -->
        <el-table-column :width="60" label="" align="left" class-name="all_com all_com_left">
          <!-- 自定义全选框 代替table selection  -->
          <template slot="header" slot-scope="scope">
            <el-tooltip :disabled="checkNum <= 0 ? true : false" :content="`Select all up to ${checkNum}`" placement="top">
              <el-checkbox class="checkbox_all" v-model="isCheck" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
              </el-checkbox>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="com_box" :class="showType == 'scheduled' ? 'scheduled' : ''">
              <el-checkbox-group class="checkbox_table" v-model="multipleSelection" @change="handleCheckedChange">
                <el-checkbox :key="scope.row.ID" :label="scope.row.ID"></el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column :width="88">
          <template slot-scope="scope">
            <el-image class="like_img" :src="scope.row.TitImg && scope.row.TitImg != '没有可上传的图片' ? scope.row.TitImg + $store.state.thumbnail : '/static/images/noimg.svg'" fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.commodity')" :min-width="200" align="left">
          <template slot-scope="scope">
            <p class="color_333" style="word-break: break-word;display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;-webkit-line-clamp: 3;">
              {{ $store.getters.setTitle(scope.row.Title, 'all') }}</p>
          </template>
        </el-table-column>

        <el-table-column :label="byWay == 'Auction' ? $t('enum.startingBid') : $t('enum.price')" :width="140" align="right">
          <template slot-scope="scope">
            <span class="color_333">USD {{ scope.row.USD_Price }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.shippingFee')" :width="140" align="right">
          <template slot-scope="scope">
            <span class="color_333">{{ scope.row.US_PostageMoney != 'Free Shipping' ? 'USD' : '' }} {{ scope.row.US_PostageMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.scheduledTime')" :width="140" align="right" v-if="showType == 'scheduled'">
          <template slot-scope="scope">
            <div class="color_333">
              {{ $store.getters.separatedTime(scope.row.LastOnTime, 'cut')[0] }}<br />{{ $store.getters.separatedTime(scope.row.LastOnTime, 'cut')[1] }}
            </div>
            <!-- <span >Apr 13, 2022<br> 10:01:00 PDT</span> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.duration')" :width="140" align="right" v-if="showType == 'scheduled' && byWay == 'Auction'">
          <template slot-scope="scope">
            <div class="color_333">{{ scope.row.EffectiveDay + ' d' }}</div>
            <!-- <span >Apr 13, 2022<br> 10:01:00 PDT</span> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.acceptOffer')" :width="140" align="right" v-if="byWay == 'BuyItNow'">
          <template slot-scope="scope">
            <span class="color_333">{{ scope.row.Bargain == 1 ? $t('enum.yes') : $t('enum.no') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('enum.operate')" class-name="all_operate" align="center" :width="148" fixed="right">
          <template slot-scope="scope">
            <router-link :to="`/commodity/New?ps=${showType}&id=${scope.row.ID}`">
              <div class="color_333 hover underline">{{ $t('button.edit') }}</div>
            </router-link>
            <!-- <div v-if="showType!='scheduled'" :class="[$store.getters.applyUnload(scope.row)?'needApply':'needNotApply']"
            @click="UnloadMessageBox('Upload',scope.row)">Upload</div> -->
            <div class="color_333 hover underline" v-if="showType != 'scheduled'" @click="MessageBox('Upload', scope.row.ID)">
              {{ $t('button.relist') }}
            </div>
            <!-- scheduled 页面delete待定 -->
            <div class="color_333 hover underline" @click="MessageBox('Delete', scope.row.ID)">{{ $t('button.delete') }}</div>
            <router-link class="hover underline" v-if="['scheduled', 'Unsold'].indexOf(showType) > -1" :to="`/commodity/New?id=${scope.row.ID}&clone=new`">
              <!-- 发布相似 -->
              <span>{{ $t('button.sellSimilar') }}</span>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else class="no-data">{{ loading ? $t('enum.loading') + "..." : $t('enum.noData') }}</div>
  </div>
</template>

<script>
export default {
  name: 'watchlistcheck',
  data() {
    return {
      uploading: false,
      isCheck: false,
      isIndeterminate: false,
      multiple: 0,//默认0
      multipleSelection: [],
      multipleSelectionLimit: [],
      staticList: [],
      checkNum: 0,//显示可选个数 全部 0
      // showType:'scheduled'
      screenHeight: 200,
    }
  },
  props: {
    list: [],
    showType: {
      type: String,
      default: ''
    },
    byWay: {
      type: String,
      default: ''
    },
    loading: true
  },
  watch: {
    list: {
      // 设置默认全不选
      handler(fd) {
        if (fd.length <= 0) {
          this.multipleSelection = [];
          this.isCheck = false;
          this.isIndeterminate = false;
          this.multiple = 0;
        }
      },
      deep: true,
    }
  },
  created() {
    this.tabHeight()
  },
  mounted() {
    // 窗口大小发生变化就调用
    window.addEventListener('resize', () => {
      this.tabHeight()
    })
  },
  computed: {},
  methods: {
    // 全/不选时统计条数
    handleCheckAllChange(value) {
      var _list = [];
      /** 全选框 是否限制的个数 **/
      this.list.filter((obj, k) => {
        if (this.checkNum > 0 && k < this.checkNum) { _list.push(obj.ID) }
        else { _list.push(obj.ID) }
      });
      this.multipleSelection = value ? _list : [];
      this.isIndeterminate = false;// false全不选，true全选
      this.multiple = this.multipleSelection.length;
    },
    // 单选统计条数
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.isCheck = checkedCount === this.list.length;
      this.multiple = this.multipleSelection.length;// 勾选选中的
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;// 勾选的长度范围
    },
    handleSelectionChange(val) {
      let that = this;
      this.$nextTick(function () {
        that.multipleSelection = val;
        that.multiple = that.multipleSelection.length;
        console.log(this.multipleSelection, val, this.multiple)

      })
    },
    //弹框
    UnloadMessageBox(val, obj, status) {
      let that = this;
      // console.log('Upload', obj);
      this.$emit("dialogSwitch", val, obj)
    },
    // 批量/单条上架、删除 弹框
    MessageBox(val, obj, status) {
      let that = this;
      var data = [];
      let msg = '';
      if (obj == undefined) {
        data = this.multipleSelection;
        if (val == 'Upload') {
          msg = `<div class="p_txt color_333">${this.$t('tips.relistItemMore').replace(/\{a}/g, data.length)}</div>`;
          // msg = '<div class="p_txt color_333">Do you want to relist these ' + data.length + ' items right now?</div>';
        } else {
          msg = `<div class="p_txt color_333">${this.$t('tips.deleteItemMore').replace(/\{a}/g, data.length)}</div>`;
          // msg = `<div class="p_txt color_333">Do you want to delete these ${ data.length} items?</div>`;
        }
      } else {
        data.push(obj);
        if (val == 'Upload') {
          msg = `<div class="p_txt color_333">${this.$t('tips.relistItem')}</div>`;
        } else {
          msg = `<div class="p_txt color_333">${this.$t('tips.deleteItem')}</div>`;
        }
      }
      if (data.length > 0) {
        let title = val;
        switch (val) {
          case 'Delete':
            title = this.$t('enum.delete')
            break;
          case 'Upload':
            title = this.$t('enum.relist')
            break;
          default:
            break;
        }
        this.$confirm(msg, title, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('button.yes'),
          confirmButtonClass: val == 'Delete' ? "confirm-del" : "confirm-box",
          cancelButtonText: this.$t('button.no'),
        }).then(() => {
          // Yes
          console.log(data, val)
          /* upload:ReleaseCommodity Delete:Delete*/
          if (val == 'Upload' || val == 'Delete') {
            //上架、删除
            let api = val == 'Upload' ? 'ReleaseCommodity' : 'Delete';
            that.uploading = true;
            let params = {
              CommodityIds: data
            };
            console.log(params);
            let fun = function (res) {
              //console.log(res)  
              that.uploading = false;
              that.$emit('getData'); // 调用scheduled的getData方法（获取我的 商品列表）
              if (res.result) { }
            };
            that.$post(api, params)
              .then((res) => {
                console.log("axios-res:", res);
                fun(res);
              })
              .catch((err) => {
                console.log(err);
                that.uploading = false;
              });
          }
        }).catch(() => {
          // No   
        });
      }
    },
    // 获取高度
    tabHeight() {
      this.screenHeight = document.body.clientHeight;
      let Sheight = this.screenHeight - 70 - 70 - 62 - 56 - 41 - 163
      this.$nextTick(() => {
        this.screenHeight = Sheight
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .com_box p {
  word-break: break-word;
} */
/deep/.el-table .el-table__cell:nth-child(2) {
  padding: 12px 0;
}

/deep/.el-table .el-table__cell:nth-child(1) {
  vertical-align: middle;
}

/deep/.el-table .all_com_left .el-table__cell {
  vertical-align: auto;
}

/deep/.el-table .el-table__cell {
  vertical-align: top;
  padding: 12px 0;
}

.table_box {
  width: 100%;
}

/* .like_img {
  margin-right: 12px;
} */
.com_box {
  display: flex;
}

.com_box p {
  width: 252px;
}

.scheduled p {
  width: 250px;
}

.check_btn_box {
  display: flex;
  line-height: 30px;
  padding: 20px 0;
}

.check_btn_box i {
  color: #5f6dae;
  margin-right: 2px;
}

.check_btn {
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  color: #c8c8c8;
  border-radius: 4px;
  margin-left: 12px;
  border: 1px solid #c8c8c8;
  cursor: pointer;
}

.check_btn.on {
  color: #5f6dae;
  border-color: #5f6dae;
}

.all_operate div {
  cursor: pointer;
}

.all_operate div:hover {}

/deep/.el-table th.el-table__cell>.cell {
  padding: 0 12px;
}

/deep/.el-table th.all_operate>.cell {
  padding: 0 16px;
}

/deep/ .el-table__fixed-right::before {
  background-color: transparent;
}

/deep/ .has-gutter {
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/tablecheck.vue